<ion-card *ngIf="assistance">
  <ion-card-header>
    <ion-toolbar class="editor-toolbar">
      <ion-buttons slot="start">
        <ion-button
          *ngIf="editable && !FeatureFlags.assistanceEditor_autosave"
          (click)="debouncedSave()"
          color="success"
          expand="block"
          fill="solid"
          [disabled]="assistanceEditorModalService.formStatus?.isNotOk()"
          data-cy="btnSave"
        >
          <ion-icon name="save"></ion-icon>
          <span class="ion-hide-md-down">&nbsp;Uložit</span>
        </ion-button>

        <ion-button
          *ngIf="editable"
          (click)="debouncedSaveWithPopup()"
          color="success"
          expand="block"
          fill="solid"
          [disabled]="assistanceEditorModalService.formStatus?.isNotOk()"
          data-cy="btnSaveAndClose"
        >
          <ion-icon name="save"></ion-icon>
          <span class="ion-hide-md-down">&nbsp;Uložit a zavřít</span>
        </ion-button>

        <ion-button
          *ngIf="editable"
          (click)="editableHandler.forceEditable(false)"
          color="secondary"
          expand="block"
          fill="solid"
          [disabled]="assistance.isNotSavedInDatabase() || !assistanceEditorModalService.formStatus?.isSettled()"
        >
          <ion-icon name="eye"></ion-icon>
          <span class="ion-hide-md-down">Zobrazit</span>
        </ion-button>
        <ion-button
          *ngIf="!editable && !assistance.isBilled"
          (click)="editableHandler.forceEditable(true)"
          color="secondary"
          expand="block"
          fill="solid"
          data-cy="btnEdit"
        >
          <ion-icon name="create"></ion-icon>
          <span class="ion-hide-md-down">Upravit</span>
        </ion-button>

        <ion-button [disabled]="assistance.isNotSavedInDatabase() || !assistanceEditorModalService.formStatus?.isSettled()" (click)="createTemplate()" color="secondary" expand="block" class="ion-hide-md-down" fill="solid">
          <ion-icon name="create"></ion-icon>
          <span>Vytvořit šablonu</span>
        </ion-button>

        <ion-button
          (click)="duplicate()"
          color="secondary"
          expand="block"
          class="ion-hide-md-down"
          fill="solid"
          [disabled]="!isAssistanceDuplicable()"
        >
          <ion-icon name="copy"></ion-icon>
          <span>Duplikovat</span>
        </ion-button>

        <ion-text
          *ngIf="editable"
          color="{{ assistanceEditorModalService.formStatus?.color }}"
          class="ion-padding-horizontal"
        >
          {{ assistanceEditorModalService.formStatus?.text }}
          <span
            style="font-weight: bold"
            [attr.data-last-save]="assistanceEditorModalService.formStatus?.lastSavedTimestamp"
          >
            {{ assistanceEditorModalService.formStatus?.explanationText }}
          </span>
        </ion-text>
      </ion-buttons>

      <ion-buttons slot="end">
        <ion-button class="ion-hide-lg-up" (click)="isPopoverOpen = !isPopoverOpen">
          <ion-icon name="ellipsis-vertical"></ion-icon>
        </ion-button>

        <ion-popover [isOpen]="isPopoverOpen">
          <ng-template>
            <ion-list>
              <ion-item [disabled]="assistance.isNotSavedInDatabase() || !assistanceEditorModalService.formStatus?.isSettled()" (click)="createTemplate()">
                Vytvořit šablonu
              </ion-item>
              <ion-item *ngIf="canShowDeleteButton()" (click)="deleteWithConfirmation()">Smazat</ion-item>
            </ion-list>
          </ng-template>
        </ion-popover>

        <ion-button
          *ngIf="canShowDeleteButton()"
          class="ion-hide-md-down"
          color="danger"
          expand="block"
          fill="solid"
          data-cy="btnDelete"
          (click)="deleteWithConfirmation()"
          [disabled]="assistanceEditorModalService.formStatus?.isSaving()"
        >
          <ion-icon name="trash"></ion-icon>
          <span class="ion-hide-md-down">Smazat</span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-card-header>

  <ion-card-content>
    <form *ngIf="form" [formGroup]="form" id="ngForm" (submit)="$event.preventDefault()">
      <ion-list *ngIf="!editable" lines="full" class="accomodate-toolbar-above ion-no-margin ion-no-padding">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="12" size-md="6" class="formFirstCol">
              <ion-item-divider>
                <ion-label>Základní</ion-label>
              </ion-item-divider>

              <ion-item>
                <ion-label>Klient</ion-label>
                <div>{{ assistance.clientName }}</div>
              </ion-item>

              <ion-grid class="ion-no-padding">
                <ion-row>
                  <ion-col size="6" class="ion-no-padding">
                    <ion-item>
                      <ion-label>Plánovaná od</ion-label>
                      {{ assistance.plannedFrom | date: 'dd.MM.yyyy HH:mm' }}
                    </ion-item>
                  </ion-col>
                  <ion-col size="6" class="ion-no-padding">
                    <ion-item>
                      <ion-label>Plánovaná do</ion-label>
                      {{ assistance.plannedTo | date: 'dd.MM.yyyy HH:mm' }}
                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-grid>

              <ion-grid class="ion-no-padding">
                <ion-row>
                  <ion-col size="6" class="ion-no-padding">
                    <ion-item>
                      <ion-label>Reálně od</ion-label>
                      {{ assistance.realizedFrom | date: 'dd.MM.yyyy HH:mm' }}
                    </ion-item>
                  </ion-col>
                  <ion-col size="6" class="ion-no-padding">
                    <ion-item>
                      <ion-label>Reálně do</ion-label>
                      {{ assistance.realizedTo | date: 'dd.MM.yyyy HH:mm' }}
                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-grid>

              <ion-item>
                <ion-label position="floating">
                  Adresa začátku
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input formControlName="addressStart"></ion-input>
              </ion-item>
              <ion-item>
                <ion-label position="floating">
                  Adresa konce
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input formControlName="addressEnd"></ion-input>
              </ion-item>
              <ion-item>
                <ion-label>Asistent</ion-label>
                <ul *ngIf="sortedAssignments && sortedAssignments.length">
                  <li *ngFor="let a of sortedAssignments">
                    <span class="name">{{ a.fullname }}</span>
                    <span class="transit">
                      (přejezd
                      <span class="duration">{{ a.transitDurationMinutes }} min</span>
                      )
                    </span>
                  </li>
                </ul>
              </ion-item>

              <ion-item>
                <ion-label>Klíčový koordinátor</ion-label>
                <div>{{ assistance.keyCoordinatorName }}</div>
              </ion-item>

              <ion-item>
                <ion-label>Krátký popis</ion-label>
                {{ assistance.shortDescription }}
              </ion-item>

              <ion-item>
                <ion-label>Poznámka koordinace</ion-label>
                <ion-textarea readonly="true" class="ion-padding-start">{{ assistance.coordinatorNote }}</ion-textarea>
              </ion-item>
            </ion-col>

            <ion-col size="12" size-md="6" class="params">
              <ion-item-divider>
                <ion-label>Parametry</ion-label>
              </ion-item-divider>

              <ion-item>
                <ion-checkbox formControlName="isSleepover" labelPlacement="start">Sleva</ion-checkbox>
              </ion-item>

              <ion-item>
                <ion-select
                  formControlName="preferredAssistantGenderId"
                  label="Preferované pohlaví asistenta"
                  labelPlacement="floating"
                >
                  <ion-select-option *ngFor="let gender of genders$ | async" [value]="gender.id">
                    {{ gender.gender }}
                  </ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item>
                <ion-checkbox formControlName="strongAssistantNeeded" labelPlacement="start">
                  Vyžaduje silného
                </ion-checkbox>
              </ion-item>

              <ion-item>
                <ion-checkbox formControlName="advancedAssistantNeeded" labelPlacement="start">
                  Vyžaduje pokročilého
                </ion-checkbox>
              </ion-item>

              <ion-item>
                <ion-checkbox formControlName="isNotToBePrimarilyAssigned" labelPlacement="start">
                  Primárně neobsazovat
                </ion-checkbox>
              </ion-item>

              <ion-item>
                <ion-checkbox formControlName="isLateOrder" labelPlacement="start">Pozdě objednaná</ion-checkbox>
              </ion-item>

              <ion-item>
                <ion-label>Placeno organizací</ion-label>
                <ion-icon *ngIf="!assistance.isPaidInternally" slot="end" name="square-outline"></ion-icon>
                <ion-icon *ngIf="assistance.isPaidInternally" slot="end" name="checkbox"></ion-icon>
              </ion-item>

              <ion-item>
                <ion-label>Nepřímá práce</ion-label>
                <ion-icon *ngIf="!assistance.nonClientWork" slot="end" name="square-outline"></ion-icon>
                <ion-icon *ngIf="assistance.nonClientWork" slot="end" name="checkbox"></ion-icon>
              </ion-item>

              <ion-item-divider>
                <ion-label>Ostatní</ion-label>
              </ion-item-divider>

              <ion-item>
                <ion-label>Primární kontakt na klienta</ion-label>
                <!--							{{ assistance.client | getPrimaryContact }}-->
              </ion-item>

              <ion-item>
                <ion-label>Odesláno klientovi</ion-label>
                <ion-icon *ngIf="!assistance.isSentToClient" slot="end" name="square-outline"></ion-icon>
                <ion-icon *ngIf="assistance.isSentToClient" slot="end" name="checkbox"></ion-icon>
              </ion-item>

              <ion-item>
                <ion-label>Zobrazovat na burze</ion-label>
                <ion-icon *ngIf="!assistance.isShowInExchange" slot="end" name="square-outline"></ion-icon>
                <ion-icon *ngIf="assistance.isShowInExchange" slot="end" name="checkbox"></ion-icon>
              </ion-item>

              @if (FeatureFlags.assistanceEditor_allowJournalEntryEditor) {
                <ion-item-divider>
                  <ion-label>Zápis</ion-label>
                </ion-item-divider>

                <ion-item>
                  <div *ngIf="assistance.journalEntryContent" [innerHTML]="assistance.journalEntryContent"></div>
                  <div *ngIf="!assistance.journalEntryContent" class="ion-text-center ion-padding">
                    <ion-label color="medium">Žádný zápis</ion-label>
                  </div>
                </ion-item>
              }
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-item-divider>
                <ion-label>Finance</ion-label>
              </ion-item-divider>

              <app-assistance-editor-finance-viewer
                [assistanceId]="assistance.id"
              ></app-assistance-editor-finance-viewer>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-item-divider>
                <ion-label>Zpětná vazba</ion-label>
              </ion-item-divider>

              <ion-item>
                <ion-label>Zpětná vazba od klienta</ion-label>
                {{ assistance.clientFeedback }}
              </ion-item>
              <ion-item>
                <ion-label>Zpětná vazba od asistenta</ion-label>
                <app-assistant-feedback-viewer
                  [assignments]="assistance.assignments"
                  [currentUser]="currentUser$ | async"
                ></app-assistant-feedback-viewer>
              </ion-item>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-item-divider>
                <ion-label>Detailní popis výkonu</ion-label>
              </ion-item-divider>

              <ion-item>
                <div
                  [innerHTML]="assistance.detailedDescription | bypassHtmlSanitizer"
                  class="detailedDescription e-rte-content"
                ></div>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>

      <ng-container *ngIf="editable" class="accomodate-toolbar-above">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="12" size-md="6" class="formFirstCol">
              <ion-list lines="full" class="ion-no-margin ion-no-padding">
                <ion-item-divider>
                  <ion-label>Základní</ion-label>
                </ion-item-divider>

                <ion-item>
                  <ion-label>Klient</ion-label>
                  <ion-text color="danger">&nbsp;*</ion-text>
                  <app-client-select formControlName="clientId"></app-client-select>
                </ion-item>

                <ion-item class="ion-no-padding">
                  <ion-grid class="ion-no-padding">
                    <ion-row>
                      <ion-col size="12" sizeMd="6" class="ion-no-padding">
                        <ion-row>
                          <ion-item lines="none" [disabled]="form.controls.plannedFrom.disabled">
                            <ion-label position="stacked">
                              Plánovaná od
                              <ion-text color="danger">*</ion-text>
                            </ion-label>
                            <app-date-time-input formControlName="plannedFrom"></app-date-time-input>
                          </ion-item>
                        </ion-row>
                      </ion-col>

                      <ion-col size="12" sizeMd="6" class="ion-no-padding">
                        <ion-row>
                          <ion-item lines="none" [disabled]="form.controls.plannedTo.disabled">
                            <ion-label position="stacked">
                              Plánovaná do
                              <ion-text color="danger">*</ion-text>
                            </ion-label>
                            <app-date-time-input formControlName="plannedTo"></app-date-time-input>
                          </ion-item>
                        </ion-row>
                      </ion-col>
                    </ion-row>

                    <ion-row data-cy="dateValidationErrors">
                      <ion-col
                        size="12"
                        class="validation-item ion-no-padding"
                        *ngIf="form?.errors?.validPlannedDateTimePast"
                      >
                        Plánované datum/čas nesmí být v minulosti.
                      </ion-col>
                      <ion-col
                        size="12"
                        class="validation-item ion-no-padding"
                        *ngIf="form?.errors?.isPlannedDateTimeSoonerThanConfigAllows"
                      >
                        Nastavený parametr umožňuje upravovat události pouze
                        {{ form?.errors?.isPlannedDateTimeSoonerThanConfigAllows }}
                        dní do minulosti..
                      </ion-col>
                      <ion-col
                        size="12"
                        class="validation-item ion-no-padding"
                        *ngIf="form?.errors?.validPlannedDatetimeToLaterThanFrom"
                      >
                        Konec asistence musí být po jejím začátku.
                      </ion-col>
                      <ion-col
                        size="12"
                        class="validation-item ion-no-padding"
                        *ngIf="form?.errors?.isOverlappingAnyOtherAssistanceForTheSameClient"
                      >
                        Asistence se překrývá s jinou:
                        <ul class="overlap-error-list">
                          <li *ngFor="let dateRange of form?.errors?.isOverlappingAnyOtherAssistanceForTheSameClient">
                            {{ dateRange.from | date: 'dd.MM.yyyy HH:mm' }} -
                            {{ dateRange.to | date: 'dd.MM.yyyy HH:mm' }}
                          </li>
                        </ul>
                      </ion-col>
                      <ion-col
                        size="12"
                        class="validation-item ion-no-padding"
                        *ngIf="form?.errors?.isOverlappingAnyOtherAssistanceForTheSameAssistant"
                      >
                        Asistent již je přiřazen k jiné asistenci:
                        <ul class="overlap-error-list">
                          <li
                            *ngFor="let dateRange of form?.errors?.isOverlappingAnyOtherAssistanceForTheSameAssistant"
                          >
                            {{ dateRange.from | date: 'dd.MM.yyyy HH:mm' }} -
                            {{ dateRange.to | date: 'dd.MM.yyyy HH:mm' }}
                          </li>
                        </ul>
                      </ion-col>

                      <ion-col size="12" class="ion-no-padding" *ngIf="recurrenceEditorShowManager.showStatus">
                        <ion-item lines="none">
                          <ion-row>
                            <ion-col size="12" class="ion-no-padding">
                              <app-assistance-editor-recurrence-editor
                                formControlName="rrule"
                                [intendedTimeForUNTIL]="form.value.plannedFrom?.toDate()"
                                data-cy="recurrenceEditor"
                              ></app-assistance-editor-recurrence-editor>
                            </ion-col>
                            <ion-col
                              size="12"
                              class="validation-item ion-no-padding"
                              *ngIf="form?.errors?.recurrenceUntilLaterThanPlannedFrom"
                            >
                              Konec opakování musí být později než začátek.
                            </ion-col>
                            <ion-col
                              size="12"
                              class="validation-item ion-no-padding"
                              *ngIf="form?.errors?.isLateOrderedAndRecurrent"
                            >
                              Tato asistence je pozdě objednaná - nelze ji založit jako opakovanou.
                            </ion-col>
                            <ion-col
                              size="12"
                              class="validation-item ion-no-padding"
                              *ngIf="form?.errors?.recurrentAssistanceHasAtLeastOneOccurrence"
                            >
                              Z takto nastavených hodnot opakování nevychází žádná reálná asistence.
                            </ion-col>
                          </ion-row>
                        </ion-item>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-item>

                <ion-item class="ion-no-padding">
                  <ion-grid class="ion-no-padding">
                    <ion-row>
                      <ion-col size="12" sizeMd="6" class="ion-no-padding">
                        <ion-row>
                          <ion-item lines="none" [disabled]="form.controls.realizedFrom.disabled">
                            <ion-label position="stacked">Reálně od</ion-label>
                            <app-date-time-input formControlName="realizedFrom"></app-date-time-input>
                            <ion-row
                              class="realizedTimeSubRow"
                              *ngIf="!form.controls.realizedFrom.disabled && !realizedFromPicker?.value"
                            >
                              <ion-button
                                (click)="fillRealizedInputAccordingToPlannedValue('realizedFrom', 'plannedFrom')"
                                class="ion-text-wrap realizedButtonsFromPlanned"
                                expand="block"
                                fill="outline"
                                size="default"
                              >
                                vyplnit podle plánovaného času
                              </ion-button>
                            </ion-row>
                          </ion-item>
                        </ion-row>
                      </ion-col>

                      <ion-col size="12" sizeMd="6" class="ion-no-padding">
                        <ion-row>
                          <ion-item lines="none" [disabled]="form.controls.realizedTo.disabled">
                            <ion-label position="stacked">Reálně do</ion-label>
                            <app-date-time-input formControlName="realizedTo"></app-date-time-input>
                            <ion-row
                              class="realizedTimeSubRow"
                              *ngIf="!form.controls.realizedTo.disabled && !realizedToPicker?.value"
                            >
                              <ion-button
                                (click)="fillRealizedInputAccordingToPlannedValue('realizedTo', 'plannedTo')"
                                class="ion-text-wrap realizedButtonsFromPlanned"
                                expand="block"
                                fill="outline"
                                size="default"
                              >
                                vyplnit podle plánovaného času
                              </ion-button>
                            </ion-row>
                          </ion-item>
                        </ion-row>
                      </ion-col>
                    </ion-row>

                    <ion-row>
                      <ion-col
                        size="12"
                        class="validation-item ion-no-padding"
                        *ngIf="realizedValidationErrorsMessages.length !== 0"
                      >
                        {{ realizedValidationErrorsMessages.join(' ') }}
                      </ion-col>
                    </ion-row>
                    <ion-row *ngIf="realizedValidationErrorsMessages.length === 0 && isWarningForRealizedDatesCache">
                      <ion-col size="12" class="warning-item ion-no-padding">
                        Pro ukončení asistence vyplňte reál. čas
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-item>

                <ion-item>
                  <ion-label position="floating">
                    Adresa začátku
                    <ion-text color="danger">*</ion-text>
                  </ion-label>
                  <ion-input data-cy="inputAddressStart" formControlName="addressStart"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="floating">
                    Adresa konce
                    <ion-text color="danger">*</ion-text>
                  </ion-label>
                  <ion-input data-cy="inputAddressEnd" formControlName="addressEnd"></ion-input>
                </ion-item>

                <app-assistance-editor-assistant-select
                  [urid]="assistance.URID"
                  [assistanceRange]="getAssistanceRangeFromForm()"
                  [disabled]="isAssistantSelectDisabled()"
                  [filterOverrides]="getAssistantSelectFilterOverrides()"
                  (uridChanged)="uridChangeReportedFromAssistantSelect($event)"
                  data-cy="assistantSelect"
                ></app-assistance-editor-assistant-select>

                <ion-item>
                  <ion-label position="floating">
                    Klíčový koordinátor
                    <ion-text color="danger">*</ion-text>
                  </ion-label>
                  <app-key-coordinator-select formControlName="keyCoordinatorId"></app-key-coordinator-select>
                </ion-item>

                <ion-item>
                  <ion-label position="floating">Krátký popis</ion-label>
                  <ion-input formControlName="shortDescription"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="floating">Poznámka koordinace</ion-label>
                  <ion-textarea formControlName="coordinatorNote"></ion-textarea>
                </ion-item>
              </ion-list>
            </ion-col>

            <ion-col size="12" size-md="6" class="params">
              <ion-list>
                <ion-item-divider>
                  <ion-label>Parametry</ion-label>
                </ion-item-divider>

                <ion-item>
                  <ion-checkbox formControlName="isSleepover" labelPlacement="start">Sleva</ion-checkbox>
                </ion-item>

                <ion-item>
                  <ion-select
                    formControlName="preferredAssistantGenderId"
                    label="Preferované pohlaví asistenta"
                    labelPlacement="floating"
                  >
                    <ion-select-option *ngFor="let gender of genders$ | async" [value]="gender.id">
                      {{ gender.gender }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>

                <ion-item>
                  <ion-checkbox formControlName="strongAssistantNeeded" labelPlacement="start">
                    Vyžaduje silného
                  </ion-checkbox>
                </ion-item>

                <ion-item>
                  <ion-checkbox formControlName="advancedAssistantNeeded" labelPlacement="start">
                    Vyžaduje pokročilého
                  </ion-checkbox>
                </ion-item>

                <ion-item>
                  <ion-checkbox formControlName="isNotToBePrimarilyAssigned" labelPlacement="start">
                    Primárně neobsazovat
                  </ion-checkbox>
                </ion-item>

                <ion-item>
                  <ion-checkbox formControlName="isLateOrder" labelPlacement="start">Pozdě objednaná</ion-checkbox>
                </ion-item>

                <ion-item>
                  <ion-checkbox formControlName="isPaidInternally" labelPlacement="start">
                    Placeno organizací
                  </ion-checkbox>
                </ion-item>

                <ion-item>
                  <ion-checkbox
                    labelPlacement="start"
                    helperText="Asistent nebude moci zadávat reálné časy od/do"
                    formControlName="nonClientWork"
                  >
                    Nepřímá práce
                  </ion-checkbox>
                </ion-item>

                <ion-item-divider>
                  <ion-label>Ostatní</ion-label>
                </ion-item-divider>

                <ion-item>
                  <ion-checkbox labelPlacement="start" formControlName="isSentToClient">
                    Odesláno klientovi
                  </ion-checkbox>
                </ion-item>

                <ion-item>
                  <ion-checkbox
                    labelPlacement="start"
                    formControlName="isShowInExchange"
                    [disabled]="
                      recurrenceEditingMode !== RecurrenceEditingMode.currentOccurrence &&
                      recurrenceEditingMode !== RecurrenceEditingMode.none
                    "
                  >
                    Zobrazovat na burze
                  </ion-checkbox>
                </ion-item>

                @if (FeatureFlags.assistanceEditor_allowJournalEntryEditor) {
                  <ion-item-divider>
                    <ion-label>Zápis</ion-label>
                  </ion-item-divider>

                  <ion-item>
                    <app-tag-editor
                      formControlName="journalEntryContent"
                      [clientId]="currentClientId"
                      [debug]="false"
                      placeholder="TAG_EDITOR.ENTER_NOTES_PLACEHOLDER"
                    ></app-tag-editor>
                  </ion-item>
                }
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-list>
                <ion-item-divider>
                  <ion-label>Zpětná vazba</ion-label>
                </ion-item-divider>

                <ion-item>
                  <ion-label>Zpětná vazba od klienta</ion-label>
                  {{ assistance.clientFeedback }}
                </ion-item>
                <ion-item>
                  <ion-label>Zpětná vazba od asistenta</ion-label>
                  <app-assistant-feedback-viewer
                    [assignments]="assistance.assignments"
                    [currentUser]="currentUser$ | async"
                    [allowRemoveFeedback]="true"
                  ></app-assistant-feedback-viewer>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-list>
                <ion-item-divider>
                  <ion-label>Detailní popis výkonu</ion-label>
                </ion-item-divider>

                <ion-item>
                  <ejs-richtexteditor
                    #detailedDescriptionRTE
                    class="detailedDescriptionRte"
                    name="detailedDescription"
                    formControlName="detailedDescription"
                    [saveInterval]="10"
                    [toolbarSettings]="richTextEditorToolbarSettings"
                    [pasteCleanupSettings]="rtePasteCleanupSettings"
                  ></ejs-richtexteditor>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ng-container>
      <ion-footer>
        <app-assistance-editor-assistance-status
          formControlName="statusId"
          [editable]="editable"
          [formStatus]="assistanceEditorModalService.formStatus"
          [assistance]="assistance"
          [statusValidationInputs]="{
            realizedFrom: assistance.realizedFrom,
            realizedTo: assistance.realizedTo,
          }"
          (advanceStatusRequested)="doAdvanceStatus()"
          (cancelAssistanceRequested)="cancelAssistanceWithConfirmation()"
        ></app-assistance-editor-assistance-status>
      </ion-footer>
    </form>
  </ion-card-content>
</ion-card>
